import React, { useState, useMemo } from 'react'
import { Container, Box } from '@material-ui/core'

import { Page, ContentHeader, LoadingFeedback } from 'components'

import {
  SuppliersQuestionnairesTabHeader,
  SupplierQuestionsTable,
  SupplierQuestionModal,
} from './components'

import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'
import useStyles from './styles'

import * as service from 'service'

const SuppliersQuestionnairesReply = ({ match }) => {
  const [loading, setLoading] = useState(false)
  const [currentTab, setCurrentTab] = useState('pending')
  const [selectedQuestion, setSelectedQuestion] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)

  const classes = useStyles()
  const snackbar = useSnackbar()

  const { questionnaireId } = match.params

  const { response, isLoading, refresh } = useFetch(
    service.dponet.questionnaires.get,
    {
      questionnaireId,
    },
    [],
    !!questionnaireId,
  )

  const {
    response: questionsResponse,
    isLoading: isLoadingQuestions,
    refresh: refreshQuestions,
  } = useFetch(
    service.dponet.supplierQuestionnaires.getQuestions,
    {
      questionnaireId,
    },
    [],
    !!questionnaireId,
  )

  const questionnaire = response?.data?.questionnaire || {}
  const questions = questionsResponse?.data?.quizQuestionTemplates || []
  const stats = questionsResponse?.data?.stats || {
    total: 0,
    answered: 0,
    pending: 0,
  }

  const filteredQuestions = useMemo(() => {
    if (currentTab === 'answered') {
      return questions.filter((q) => !!q.answer)
    }
    if (currentTab === 'todos') {
      return questions
    }
    return questions.filter((q) => !q.answer)
  }, [currentTab, questions])

  const handleAnswerQuestion = async (
    questionId,
    alternativeId,
    justification,
    evidence,
    answerId,
  ) => {
    setLoading(true)
    try {
      const question = questions.find((q) => q.id === questionId)
      const isUpdate = !!answerId || !!question?.answer

      const data = {
        questionnaireId,
        questionId,
        alternativeId,
        answerId: answerId ?? question?.answer?.id,
        justification,
        evidence,
      }

      if (isUpdate) {
        await service.dponet.supplierQuestionnaires.updateAnswer(data)
        snackbar.open({
          message: 'Resposta atualizada com sucesso!',
          variant: 'success',
        })
      } else {
        await service.dponet.supplierQuestionnaires.createAnswer(data)
        snackbar.open({
          message: 'Resposta salva com sucesso!',
          variant: 'success',
        })
      }

      refreshQuestions()
      refresh()
    } catch (error) {
      snackbar.open({
        message:
          error?.response?.data?.error?.message ||
          'Erro ao salvar resposta. Tente novamente.',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const handleTabChange = (tabId) => {
    setCurrentTab(tabId)
  }

  const handleAnswerClick = (question) => {
    setSelectedQuestion(question)
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
    setSelectedQuestion(null)
  }

  return (
    <>
      <Page title="Responder questionário - Fornecedor">
        <LoadingFeedback open={isLoading || isLoadingQuestions || loading} />
        <Container maxWidth={false} className={classes.container}>
          <ContentHeader title={questionnaire?.name} />
          <Box mt={3}>
            <SuppliersQuestionnairesTabHeader
              questionnaire={questionnaire}
              questions={questions}
              stats={stats}
              isLoading={isLoading || isLoadingQuestions || loading}
              onTabChange={handleTabChange}
              currentTab={currentTab}
            />
          </Box>
          <SupplierQuestionsTable
            questions={filteredQuestions}
            isLoading={isLoading || isLoadingQuestions || loading}
            onAnswerClick={handleAnswerClick}
          />
        </Container>
      </Page>
      <SupplierQuestionModal
        open={modalOpen}
        onClose={handleCloseModal}
        question={selectedQuestion}
        onAnswer={handleAnswerQuestion}
        questionnaireId={questionnaireId}
      />
    </>
  )
}

export default SuppliersQuestionnairesReply
